import { makeStyles } from '@material-ui/core/styles';

export const useButtonStyles = makeStyles(theme => ({
	root: {
		width: props => props.width,
		height: props => props.height,
		textTransform: props => (props.noTextTransform ? 'none' : 'uppercase'),
		borderRadius: 50,
		fontWeight: 600,
		border: props => `1px solid ${theme.palette[props.rest.color].main}`,
		whiteSpace: 'nowrap',
		'&:hover': {
			backgroundColor: props => (props.rest.color === 'primary' ? 'white' : theme.palette.secondary.main),
			color: props => props.rest.color === 'secondary' && 'white',
			border: props => `1px solid ${theme.palette[props.rest.color].main}`,
			boxShadow: 'none'
		},
		'&:focus': {
			backgroundColor: props => (props.rest.color === 'primary' ? '#D9671B' : theme.palette.secondary.main),
			color: 'white',
			textTransform: props => (props.noTextTransform ? 'none' : 'uppercase'),
			boxShadow: 'none',
			'& img': {
				filter: 'invert(100%)'
			}
		},
		'&:disabled': {
			opacity: '20%',
			color: props => props.rest.color === 'secondary' && 'white',
			backgroundColor: props => theme.palette[props.rest.color].main
		}
	},
	startIcon: {
		marginRight: 4
	},
	endIcon: {
		marginLeft: 5,
		marginRight: -8,
		'&.MuiButton-iconSizeSmall': {
			marginRight: -5
		}
	},
	textSizeSmall: {
		padding: '5px 11px'
	}
}));
